module.exports = __webpack_public_path__ + "static/media/Arrow-up.a9c8619f.svg";